class ShopTheLookCard extends HTMLElement {
  connectedCallback () {
    this.els = {
      sizeSelect: this.querySelector('[data-shop-the-look-card-el="sizeSelect"]'),
      hiddenVariantId: this.querySelector('[data-shop-the-look-card-el="hiddenVariantId"]'),
    }

    this.init()
  }

  init () {
    this.setupEventListeners()
  }

  setupEventListeners () {
    this.els.sizeSelect.addEventListener('change', this.handleSizeChange.bind(this))
  }

  handleSizeChange (event) {
    event.preventDefault()

    const selectedSize = event.target.value

    this.els.hiddenVariantId.value = selectedSize
  }
}

customElements.define('shop-the-look-card', ShopTheLookCard)
